export default {
  name: 'Atooltip',
  props: {
    content: { type: String, default: () => 'Bottom center' },
    placement: { type: String, default: () => 'bottom' },
    effect: { type: String, default: () => 'light' },
  },
  render() {
    const { ...attrs } = this.$attrs;
    return this.$slots.default && (
      <el-tooltip content={this.content} placement={this.placement} effect={this.effect} {...{ attrs }}>
        <span>{this.$slots.default}</span>
      </el-tooltip>
    );
  }
}